export default __webpack_public_path__ + "static/media/instagram.26f2fd28.svg";